module.exports = __webpack_public_path__ + "static/hp_sponsorship_wildlife-33fdba79d8fab26232a5ac8952bcc47a.jpg";